import request from './request'

const getUser = (user) =>
  request(`${process.env.REACT_APP_API_URL}activity/${user}`)

export { getUser }
